// extracted by mini-css-extract-plugin
module.exports = {"shoppingCartContainer":"HotelShoppingCart-module--shoppingCartContainer","shoppingCartList":"HotelShoppingCart-module--shoppingCartList"};